<template>
  <div class="mitra-logos">
    <div
      class="flex justify-between items-center mdmax:flex-col mdmax:mb-4 border-b border-nn-100"
    >
      <div class="">
        <p class="font-bold text-xl">Logo Partner</p>
        <p class="text-sm text-nn-500 mb-6">
          Daftar logo mitra logistik dan mitra bisnis yang akan ditampilkan
          sesuai urutan pada halaman website linknau.
        </p>
      </div>
      <Button buttonText="Tambah Logo" type="primary" @action="addNew()" />
    </div>
    <div class="flex items-center gap-4 mb-4 pt-4">
      <p class="whitespace-nowrap text-nn-600">Menampilkan daftar logo:</p>
      <div class="w-40">
        <CustomSelect
          :options="partnerOptions"
          v-model="selectedPartnerOption"
          placeholder="Pilih partner"
          optionLabel="label"
          :default="selectedPartnerOption"
        />
      </div>
    </div>

    <div
      class="bg-white p-4 rounded-lg grid grid-cols-6 gap-4 mdmax:grid-cols-2"
      v-if="!!partnerLogos.length"
    >
      <div
        class="border border-neutral-100 rounded-lg flex flex-col items-center justify-center"
        v-for="logo in partnerLogos"
        :key="logo.id"
      >
        <div class="square flex w-full items-center justify-center p-2">
          <img :src="logo.image_url" v-if="logo.image_url" />
          <PlaceholderImage v-else width="80" height="80" />
        </div>

        <p class="text-sm text-neutral-600 mb-4 w-full px-2 text-center">
          {{ logo.partner_name }}
        </p>

        <div
          class="flex justify-center items-center gap-x-2 w-full border-t border-nn-100 p-2 bg-system-gray"
        >
          <Button
            buttonText=""
            type="delete"
            size="small"
            @action="toggleDeleteLogo(logo)"
            :icon="() => import('@/components/Icons/Trash')"
          />
          <Button
            buttonText=""
            type="secondary"
            size="small"
            @action="edit(logo)"
            :icon="() => import('@/components/Icons/Pencil')"
          />
        </div>
      </div>
    </div>
    <div class="text-nn-600 h-56 flex justify-center items-center" v-else>
      - Tidak ada data yang tersedia -
    </div>
    <Modal
      :modalVisible="visibleAddLogo"
      @close="toggleAddLogo"
      id="add-logo-modal"
    >
      <template slot="modal-content">
        <p class="mt-2 mb-4 font-bold text-xl text-left">
          {{ mode === "add" ? "Tambah" : "Ubah" }} Logo Mitra
        </p>
        <div class="mb-6 relative text-left flex gap-x-4 items-center">
          <div class="" v-if="currentLogo && !image">
            <p class="text-xs text-nn-500 mb-1">Logo saat ini</p>
            <div
              class="border overflow-hidden rounded-lg flex justify-center items-center w-32 text-center p-4"
            >
              <img :src="currentLogo" />
            </div>
          </div>
          <div class="" v-if="image">
            <div
              class="border overflow-hidden rounded-lg flex justify-center items-center w-32 text-center p-4"
            >
              <img :src="image" />
            </div>
          </div>
          <div class="image-upload" v-else>
            <input
              type="file"
              name="photo"
              id="photo"
              accept=".jpg, .png, .jpeg"
              ref="photo"
              @change="handleFileSelect($event)"
              class="hidden"
            />
            <label
              for="photo"
              class="border border-dashed p-4 rounded-lg flex gap-x-4 bg-nn-50 justify-center items-center border-neutral-500 text-neutral-500 text-center cursor-pointer"
            >
              <Upload width="24" height="24" />{{
                mode === "add" ? "Upload" : "Ubah"
              }}
              Logo
            </label>
          </div>
        </div>
        <div class="mb-4 text-left">
          <p class="text-sm mb-1">Mitra</p>
          <CustomSelect
            :options="partnerOptions"
            v-model="selectedPartnerOptionForAddNew"
            placeholder="Pilih partner"
            optionLabel="label"
            :default="selectedPartnerOptionForAddNew"
          />
        </div>
        <div class="mb-10 text-left">
          <TextField
            type="text"
            v-model="partnerName"
            label="Nama Mitra"
            placeholder="Masukan nama mitra"
          />
        </div>
        <div
          class="flex items-center gap-x-4 mb-10 mdmax:flex-col mdmax:items-start"
        >
          <div class="flex items-center mb-5 gap-x-4">
            <p class="text-sm font-medium">Aktif</p>
            <div class="flex gap-2 items-center">
              <Toggle v-model="isActive" id="active" />
            </div>
          </div>
          <div class="flex items-center mb-5 gap-x-4">
            <p class="text-sm font-medium">Business</p>
            <div class="flex gap-2 items-center">
              <Toggle v-model="isBusiness" id="business" />
            </div>
          </div>
          <div class="flex items-center mb-5 gap-x-4">
            <p class="text-sm font-medium">Apps</p>
            <div class="flex gap-2 items-center">
              <Toggle v-model="isApp" id="apps" />
            </div>
          </div>
        </div>

        <div class="flex justify-end items-center gap-4">
          <Button
            buttonText="Batal"
            @action="toggleAddLogo()"
            type="secondary"
            :size="isMobile ? 'full' : 'regular'"
          />
          <Button
            :buttonText="mode === 'add' ? 'Tambah' : 'Ubah'"
            @action="addLogo()"
            :size="isMobile ? 'full' : 'regular'"
          />
        </div>
      </template>
    </Modal>
    <Modal
      :modalVisible="visibleDeleteConfirmation"
      @close="visibleDeleteConfirmation = false"
      id="confirmation-logo-modal"
    >
      <template slot="modal-content">
        <div class="text-cente mt-6 mb-4">
          Apakah Anda yakin akan menghapus logo mitra ini?
        </div>
        <div class="flex justify-center items-center gap-4">
          <Button
            buttonText="Ya"
            @action="deleteItem()"
            type="secondary"
            :size="isMobile ? 'full' : 'regular'"
          />
          <Button
            buttonText="Tidak"
            @action="
              visibleDeleteConfirmation = false
              resetForm()
            "
            :size="isMobile ? 'full' : 'regular'"
          />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex"

export default {
  components: {
    Button: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/Button"),
    TextField: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/TextField"),
    Modal: () =>
      import(/* webpackChunkName: "Modal" */ "@/components/Modal/Modal"),
    Upload: () =>
      import(/* webpackChunkName: "icon" */ "@/components/Icons/Upload"),
    PlaceholderImage: () =>
      import(
        /* webpackChunkName: "icon" */ "@/components/Icons/PlaceholderImage"
      ),
    CustomSelect: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/CustomSelect"),
    Toggle: () =>
      import(/* webpackChunkName: "Toggle" */ "@/components/Toggle/Toggle")
  },
  created() {
    this.getPartnerLogosList()
  },
  data() {
    return {
      visibleAddLogo: false,
      visibleDeleteConfirmation: false,
      partnerName: "",
      isActive: false,
      isBusiness: false,
      isApp: false,
      image: "",
      mode: "",
      currentLogo: "",
      selectedPartner: null,
      partnerOptions: [
        {
          label: "Mitra Logistik",
          value: "logistic"
        },
        {
          label: "Mitra Bisnis",
          value: "merchant"
        }
      ],
      selectedPartnerOption: {
        label: "Mitra Logistik",
        value: "logistic"
      },
      selectedPartnerOptionForAddNew: {
        label: "Mitra Logistik",
        value: "logistic"
      }
    }
  },
  computed: {
    ...mapGetters("settings", ["partnerLogos"]),
    ...mapGetters("common", ["isMobile"])
  },
  watch: {
    selectedPartnerOption() {
      this.getPartnerLogosList()
    }
  },
  methods: {
    ...mapActions("common", [
      "showLoading",
      "hideLoading",
      "uploadImage",
      "setToast"
    ]),
    ...mapActions("settings", [
      "getPartnerLogos",
      "addPartnerLogo",
      "changePartnerLogo",
      "deletePartnerLogo"
    ]),
    getPartnerLogosList() {
      this.showLoading()
      const params = {
        partner_type: this.selectedPartnerOption.value
      }
      this.getPartnerLogos({ params: params }).then(() => {
        this.hideLoading()
      })
    },
    addNew() {
      this.mode = "add"
      this.resetForm()
      this.toggleAddLogo()
    },
    edit(item) {
      this.mode = "edit"
      this.currentLogo = item.image_url
      this.partnerName = item.partner_name
      this.isActive = item.is_active
      this.isBusiness = item.is_business
      this.isApp = item.is_app
      this.selectedPartner = item
      this.toggleAddLogo()
    },
    toggleDeleteLogo(item = null) {
      this.selectedPartner = item
      this.visibleDeleteConfirmation = !this.visibleDeleteConfirmation
    },
    deleteItem() {
      this.showLoading()
      this.deletePartnerLogo({ id: this.selectedPartner.id }).then(() => {
        this.hideLoading()
        this.toggleDeleteLogo()
        this.setToast({
          options: {
            type: "success",
            duration: 2000,
            primaryText: "Penghapusan Logo Berhasil",
            secondaryText: "Data telah kami simpan",
            callback: () => this.getPartnerLogosList()
          }
        })
      })
    },
    toggleAddLogo() {
      this.visibleAddLogo = !this.visibleAddLogo
      if (!this.visibleAddLogo) this.resetForm()
    },
    handleFileSelect(event) {
      this.showLoading()
      let imageData = new FormData()
      imageData.append("image", event.target.files[0])
      imageData.append("file_purpose", "partner-logo")
      this.uploadImage({ payloads: imageData }).then((res) => {
        this.hideLoading()
        this.image = res.file_url
      })
    },
    addLogo() {
      if (!this.partnerName || !this.image) {
        this.setToast({
          options: {
            type: "danger",
            duration: 2000,
            primaryText: "Pastikan Anda mengisikan informasi yang dibutuhkan",
            secondaryText: "Silakan coba lagi."
          }
        })
        return
      }
      this.showLoading()
      const payloads = {
        partner_name: this.partnerName,
        image_url: this.image,
        is_active: this.isActive,
        is_business: this.isBusiness,
        is_app: this.isApp,
        partner_type: this.selectedPartnerOptionForAddNew.value
      }
      if (this.mode === "add") {
        this.addPartnerLogo({ payloads: payloads }).then(() => {
          this.toggleAddLogo()
          this.hideLoading()
          this.setToast({
            options: {
              type: "success",
              duration: 2000,
              primaryText: "Penambahan Logo Berhasil",
              secondaryText: "Data telah kami simpan",
              callback: () => this.getPartnerLogosList()
            }
          })
        })
      } else {
        this.changePartnerLogo({
          id: this.selectedPartner.id,
          payloads: payloads
        }).then(() => {
          this.toggleAddLogo()
          this.hideLoading()
          this.setToast({
            options: {
              type: "success",
              duration: 2000,
              primaryText: "Perubahan Logo Berhasil",
              secondaryText: "Data telah kami simpan",
              callback: () => this.getPartnerLogosList()
            }
          })
        })
      }
    },
    resetForm() {
      this.partnerName = ""
      this.image = ""
      this.isActive = false
      this.isBusiness = false
      this.isApp = false
      this.currentLogo = ""
      this.selectedPartner = null
      this.selectedPartnerOptionForAddNew = {
        label: "Mitra Logistik",
        value: "logistic"
      }
    }
  }
}
</script>
